const ONE_MINUTE = 60_000;
const TEN_MINUTES = 10 * ONE_MINUTE;
const ONE_HOUR = 60 * ONE_MINUTE;

export const immutableCache = {
  staleTime: Number.POSITIVE_INFINITY,
  gcTime: ONE_HOUR,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
} as const;

export const currentCache = {
  staleTime: TEN_MINUTES,
  gcTime: ONE_HOUR,
  refetchOnMount: true,
  refetchOnWindowFocus: false,
  refetchOnReconnect: true,
} as const;
